module.exports = __webpack_public_path__ + "static/media/shoe-S.inline.7dc2ec8c.svg";